import {Expose} from 'class-transformer';

export class UserCardTypeTemplateApiModel {
  @Expose()
  id: string;

  @Expose()
  graphic: string;
}
